import { getMortgagePrice, getMortgageTerms } from './mortgageForm';

const NOT_REQUIRED_FORM_FIELDS = {
  buildingType: 'default',
  description: 'default',
  hasBillOfSale: 'default',
  hasMortgage: 'default',
  hasRepair: 'stringBool',
  paidDaily: 'stringBool',
  rooms: 'number',
  townshipId: 'location',
  regionId: 'location',
  landmarkIds: 'landmark',
  landArea: 'area',
  floor: 'floorValue',
  totalFloors: 'floorTotal'
};

const getRestItemParams = (values, res) =>
  Object.entries(NOT_REQUIRED_FORM_FIELDS).reduce((acc, [key, value]) => {
    if (values[key] === undefined) return acc;

    switch (value) {
      case 'stringBool':
        return { ...acc, [key]: values[key] === 'true' };
      case 'number':
        return { ...acc, [key]: +values[key] };
      case 'location':
        return { ...acc, location: { ...acc.location, [key]: values[key] } };
      case 'landmark':
        return values[key]?.length > 0
          ? { ...acc, location: { ...acc.location, [key]: values[key] } }
          : acc;
      case 'area':
        return { ...acc, area: { ...acc.area, land: +values[key] } };
      case 'floorValue':
        return { ...acc, floor: { ...acc.floor, value: +values[key] } };
      case 'floorTotal':
        return { ...acc, floor: { ...acc.floor, total: +values[key] } };
      default:
        return { ...acc, [key]: values[key] };
    }
  }, res);

export const convertFormToQueryInput = values => {
  const res = {
    area: {
      value: Number(values.area)
    },
    categoryId: values.categoryId,
    contact: {
      name: values.name,
      type: values.owner,
      email: values.email
    },
    isLeased: values.isLeased === 'true',
    location: {
      address: values.address,
      cityId: values.city_id,
      latitude: values.coordinates.lat,
      longitude: values.coordinates.lng
    },
    photoIds: values.photos.map(el => el.id),
    rooms: Number(values.roomsAmount),
    price: getMortgagePrice(values),
    mortgageTerms: getMortgageTerms(values)
  };

  return getRestItemParams(values, res);
};
